var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "full-container",
    },
    [
      _vm.showDetail
        ? _c(
            "slide-view",
            {
              staticClass: "d-view",
              attrs: {
                "show-close": false,
                "no-listener-class": ["bell-message-hook"],
              },
              on: { close: _vm.hiddenView },
            },
            [
              _c(
                "div",
                { staticClass: "sm-main" },
                [
                  _c(
                    "div",
                    { staticClass: "sm-main__hd" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _vm._v(" "),
                      _vm.permissionSave && _vm.onlyAnnouncement
                        ? _c(
                            "el-button",
                            {
                              staticClass: "notice-btn",
                              attrs: { icon: "el-icon-plus", type: "text" },
                              on: { click: _vm.createNotice },
                            },
                            [_vm._v("新建公告")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.onlyAnnouncement
                    ? _c(
                        "flexbox",
                        { staticClass: "menu", attrs: { wrap: "wrap" } },
                        _vm._l(_vm.menuList, function (item, index) {
                          return _c(
                            "el-badge",
                            {
                              key: index,
                              attrs: {
                                value: _vm.unreadNums[item.countKey],
                                hidden:
                                  !_vm.unreadNums[item.countKey] ||
                                  _vm.unreadNums[item.countKey] == 0,
                                max: 99,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  class: {
                                    "is-current": _vm.menuLabel == item.label,
                                  },
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.menuClick(item.label)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sm-main__bd",
                      style: { height: _vm.contentHeight },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "infinite-scroll",
                              rawName: "v-infinite-scroll",
                              value: _vm.getList,
                              expression: "getList",
                            },
                          ],
                          key: _vm.scrollKey,
                          attrs: {
                            "infinite-scroll-distance": "100",
                            "infinite-scroll-disabled": "scrollDisabled",
                          },
                        },
                        _vm._l(_vm.list, function (item, index) {
                          return _c("message-cell", {
                            key: index,
                            attrs: { data: item, "data-index": index },
                            on: {
                              detail: _vm.checkCRMDetail,
                              download: _vm.downloadError,
                              read: _vm.readMessageClick,
                              delete: _vm.deleteMessageClick,
                            },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.loading
                        ? _c("p", { staticClass: "scroll-bottom-tips" }, [
                            _vm._v("加载中..."),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.noMore
                        ? _c("p", { staticClass: "scroll-bottom-tips" }, [
                            _vm._v("没有更多了"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "flexbox",
                    { staticClass: "sm-main__ft" },
                    [
                      _c(
                        "div",
                        { staticClass: "switch-read" },
                        [
                          _c("el-switch", {
                            on: { change: _vm.refreshList },
                            model: {
                              value: _vm.isUnRead,
                              callback: function ($$v) {
                                _vm.isUnRead = $$v
                              },
                              expression: "isUnRead",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "switch-read__title" }, [
                            _vm._v("仅显示未读消息"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown",
                        {
                          attrs: { trigger: "click" },
                          on: { command: _vm.handleCommand },
                        },
                        [
                          _c("i", { staticClass: "el-icon-more more" }),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    icon: "el-icon-check",
                                    command: "read",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `全部${
                                        _vm.currentMenu.label == "all"
                                          ? ""
                                          : _vm.currentMenu.name
                                      }标记为已读`
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    icon: "wk wk-s-delete",
                                    command: "delete",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      `删除${_vm.currentMenu.name}已读消息`
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.announcementAddShow
        ? _c("new-dialog", {
            on: {
              onSubmit: _vm.announcementSubmiteSuccess,
              close: function ($event) {
                _vm.announcementAddShow = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("c-r-m-full-screen-detail", {
        attrs: {
          visible: _vm.showFullDetail,
          "crm-type": _vm.relationCrmType,
          id: _vm.relationID,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showFullDetail = $event
          },
        },
      }),
      _vm._v(" "),
      _c("today-list-detail", {
        attrs: {
          id: _vm.relationID,
          "show-today-detail": _vm.showTodayDetail,
          "today-detail-data": _vm.todayDetailData,
        },
        on: {
          deleteSuccess: _vm.todayHandle,
          createSuccess: _vm.todayHandle,
          close: function ($event) {
            _vm.showTodayDetail = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }